const BaseComponent = require('base/base-component');
class univSwitchImg extends BaseComponent{
    constructor(){
        super()
    }
    init(){
    }
}

module.exports = univSwitchImg;